import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const environment = (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined)
  ?? (import.meta.env.MODE === 'production' ? 'production' : 'development');
const release = import.meta.env.VITE_SENTRY_RELEASE as string | undefined;

const tracesSampleRate = Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.1');
const replaysSessionSampleRate = Number(import.meta.env.VITE_SENTRY_REPLAYS_SAMPLE_RATE ?? '0');
const replaysOnErrorSampleRate = Number(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ?? '1');

const apiUrl = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:4000';

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    release,

    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,

    // Propagate the trace header only to our own API — never to third parties.
    tracePropagationTargets: [apiUrl],

    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: true,
        blockAllMedia: false,
      }),
    ],
  });
}

export { Sentry };
